import script from "./AppointmentPaymentSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentPaymentSummary.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentPaymentSummary.vue?vue&type=style&index=0&id=4ac877aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac877aa"]])

export default __exports__